











import { Vue, Component } from 'vue-property-decorator';
import { focusTabName, orderListTypes } from '@/const/order.ts';
import SearchForm from '@/components/shipping/order/SearchForm.vue';

@Component({
  components: {
    SearchForm,
  },
})
export default class OrderDeliveryPrepare extends Vue {
  private orderListTypes = orderListTypes.DELIVERY_PREPARE;
  private orderSearchTypes = focusTabName.DELIVERY_TAB;
}
